import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useCloneSubTopic({ classID, chapterID, topicID }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function cloneSubTopic(data) {
    return privateFetch
      .post(`/v1/admin/class/${classID}/chapter/${chapterID}/topic/${topicID}/subtopic/clone`, data)
      .then((res) => res.data);
  }

  return useMutation(cloneSubTopic, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('chapters');
    },
  });
}

export default useCloneSubTopic;
